// Generated by scripts/build-ui-icons.mjs.
export { CaretUp as default } from "../ui/glyphs-2";
